import { ref, readonly } from 'vue';

const SPLASH_DURATION_MS = 800;
const TRIGGER_KEY = 'buylo_splash_trigger';

const isVisible = ref(false);

// Memory flag - přežije SPA navigaci, ale NE page reload
let splashShownThisPageLoad = false;

const delay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));

export function useSplashScreen() {
    const showSplash = async (): Promise<void> => {
        isVisible.value = true;
        await delay(SPLASH_DURATION_MS);
        isVisible.value = false;
    };

    const triggerSplashAfterLogin = (): void => {
        sessionStorage.setItem(TRIGGER_KEY, 'login');
    };

    const initializeSplash = async (): Promise<void> => {
        // Už byl zobrazen od posledního page load (SPA navigace)
        if (splashShownThisPageLoad) {
            return;
        }
        splashShownThisPageLoad = true;

        // Smazat trigger flag pokud existuje
        sessionStorage.removeItem(TRIGGER_KEY);
        await showSplash();
    };

    const resetSplash = (): void => {
        sessionStorage.removeItem(TRIGGER_KEY);
        splashShownThisPageLoad = false;
        isVisible.value = false;
    };

    return {
        isVisible: readonly(isVisible),
        initializeSplash,
        triggerSplashAfterLogin,
        resetSplash,
    };
}
